<template>
  <div>
    <section class="container-carousel" ref="containercarousel">
      <!-- deux images avec les titres Monaco et cote d'azur et au click on va sur la page de recherche -->
      <!-- <div class="container-fluid">
        <div class="row container-photos">
          <div
            class="col-md-6 col-photo-monaco"
            @click="goOffersList('monaco')"
          >
            <img class="h-100 photo-monaco" src="/images/monaco.jpg" alt="" />
            <h1 class="lieu-monaco ">
              MONACO
            </h1>
          </div>
          <div class="col-md-6 col-photo-azur" @click="goOffersList('france')">
            <img
              class="h-100 photo-azur"
              src="/images/cote-d-azur.jpg"
              alt=""
            />
            <h1 class="lieu-azur uppercase">
              {{ $t("translation.Cote_dazur") }}
            </h1>
          </div>
        </div>
      </div> -->

      <!-- un carousel simple avec deux images et les titres monaco et cote d'azur -->
      <!--       <div
        id="carouselHomePublic"
        class="carousel slide height-100"
        data-ride="carousel"
      >
        <ol class="carousel-indicators">
          <li
            data-target="#carouselHomePublic"
            data-slide-to="0"
            class="active"
          ></li>
          <li data-target="#carouselHomePublic" data-slide-to="1"></li>
        </ol>
        <div class="carousel-inner height-100">
          <div
            class="carousel-item active height-100 bg-carousel"
            style="background-image:url(/images/monaco.jpg);"
          >
            <div class="carousel-caption d-none d-sm-block">
              <h1 class="lieu-monaco ">
                MONACO
              </h1>
            </div>
          </div>
          <div
            class="carousel-item height-100 bg-carousel"
            style="background-image:url(/images/cote-d-azur.jpg);"
          >
            <div class="carousel-caption d-none d-sm-block">
              <h1 class="lieu-azur uppercase">
                {{ $t("translation.Cote_dazur") }}
              </h1>
            </div>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#carouselHomePublic"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
          <div class="circle-carousel"></div>
        </a>
        <a
          class="carousel-control-next"
          href="#carouselHomePublic"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
          <div class="circle-carousel"></div>
        </a>
      </div> -->

      <!-- un carousel avec quatre images et les chanp de recherche sur les images -->
      <div v-if="carouselImages.length">
        <immo-carousel-offer
          v-if="carouselImages.length"
          :images="carouselImages"
          :canEnlarge="false"
          :of_id="slugOffer"
          imageSize="home"
        />
      </div>
      <div
        v-else
        id="carouselHomePublic"
        class="carousel slide height-100"
        data-ride="carousel"
      >
        <div class="carousel-inner height-100">
          <div
            class="carousel-item active height-100 bg-carousel"
            style="background-image: url(/images/pvn1.jpg)"
          >
            <div class="carousel-caption d-none d-sm-block"></div>
          </div>
          <div
            class="carousel-item height-100 bg-carousel"
            style="background-image: url(/images/pvn2.jpg)"
          >
            <div class="carousel-caption d-none d-sm-block"></div>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#carouselHomePublic"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
          <div class="circle-carousel"></div>
        </a>
        <a
          class="carousel-control-next"
          href="#carouselHomePublic"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
          <div class="circle-carousel"></div>
        </a>
      </div>
      <div class="container-recherche">
        <div class="container elements-recherche">
          <div class="row opacity1">
            <div class="col-md-12">
              <!-- <div class="row">
                <div class="col-md-12" v-show="hasSearch">
                  {{ $t("translation.Votre_recherche") }} :
                  <span v-html="search"></span>
                  <button
                    class="btn btn-primary primary-inverse btn-sm ml-3"
                    @click="deleteSearch"
                  >
                    <icon name="times" />
                  </button>
                </div>
              </div> -->
              <div class="row">
                <div @click="onclickDropdown" class="col-md-2 offset-md-1">
                  <button
                    @click="openFilter('filter_sale')"
                    class="btn btn-primary uppercase w-100 mt-2 btn-filter"
                    :class="sale_txt ? 'btn_txt' : ''"
                  >
                    {{ sale_txt ? sale_txt : $t("translation.location_vente") }}
                  </button>
                  <div class="dropdown-filter" v-if="filter_sale">
                    <div class="d-flex flex-column">
                      <m-form-checkbox
                        class="color-white"
                        :label="$t('translation.Location')"
                        :name="$Utils.randomstring('rent')"
                        v-model="filter.rent"
                        @input="validFilter('sale', false)"
                      ></m-form-checkbox>
                      <m-form-checkbox
                        class="color-white"
                        :label="$t('translation.Vente')"
                        :name="$Utils.randomstring('sale')"
                        v-model="filter.sale"
                        @input="validFilter('sale', false)"
                      ></m-form-checkbox>
                    </div>

                    <div class="d-flex flex-row justify-content-end">
                      <button
                        class="btn btn-primary mt-2 py-1 btn-filter mr-3"
                        @click="cancelFilter('sale')"
                      >
                        {{ $t("translation.Effacer") }}
                      </button>
                      <button
                        class="btn btn-primary mt-2 py-1 btn-filter"
                        @click="closeFilters()"
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </div>
                <div @click="onclickDropdown" class="col-md-2">
                  <button
                    @click="openFilter('filter_type')"
                    class="btn btn-primary uppercase w-100 mt-2 btn-filter"
                    :class="type_txt ? 'btn_txt' : ''"
                  >
                    {{ type_txt ? type_txt : $t("translation.Type") }}
                  </button>
                  <div class="dropdown-filter" v-if="filter_type">
                    <div class="d-flex flex-column">
                      <m-form-checkbox
                        v-for="item in items_of_type_filtered"
                        :key="item.value"
                        class="mx-1 color-white"
                        :label="
                          item.text !== 'Local comm.' &&
                          item.text !== 'Murs loc. commerciaux'
                            ? $t('translation.' + item.text)
                            : item.text !== 'Local comm.'
                            ? 'Commercial local'
                            : 'Commercial premises walls'
                        "
                        v-model="filter.typesobj[item.text]"
                        :name="$Utils.randomstring(item.text)"
                        @input="validFilter('type', false)"
                      ></m-form-checkbox>
                      <!--  <m-form-select
                      class="select"
                      :name="$Utils.randomstring('type')"
                      v-model="type"
                      :items="items_type_logement"
                      @input="validFilter('type', false)"
                    ></m-form-select> -->
                    </div>
                    <div class="d-flex flex-row justify-content-end">
                      <button
                        class="btn btn-primary mt-2 py-1 btn-filter  mr-3"
                        @click="cancelFilter('type')"
                      >
                        {{ $t("translation.Effacer") }}
                      </button>
                      <button
                        class="btn btn-primary mt-2 py-1 btn-filter"
                        @click="closeFilters()"
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </div>
                <div @click="onclickDropdown" class="col-md-2">
                  <button
                    @click="openFilter('filter_piece')"
                    class="btn btn-primary uppercase w-100 mt-2 btn-filter"
                    :class="piece_txt ? 'btn_txt' : ''"
                  >
                    {{ piece_txt ? piece_txt : $t("translation.pièces") }}
                  </button>
                  <div class="dropdown-filter" v-if="filter_piece">
                    <div class="d-flex flex-column">
                      <m-form-checkbox
                        class="color-white"
                        :label="$t('translation.Studio')"
                        :name="$Utils.randomstring('studio')"
                        v-model="filter.room_1"
                        @input="validFilter('piece', false)"
                      ></m-form-checkbox>
                      <m-form-checkbox
                        class="color-white"
                        :label="'2 ' + $t('translation.pièces')"
                        :name="$Utils.randomstring('t2')"
                        v-model="filter.room_2"
                        @input="validFilter('piece', false)"
                      ></m-form-checkbox>
                      <m-form-checkbox
                        class="color-white"
                        :label="'3 ' + $t('translation.pièces')"
                        :name="$Utils.randomstring('t3')"
                        v-model="filter.room_3"
                        @input="validFilter('piece', false)"
                      ></m-form-checkbox>
                      <m-form-checkbox
                        class="color-white"
                        :label="'4 ' + $t('translation.pièces')"
                        :name="$Utils.randomstring('t4')"
                        v-model="filter.room_4"
                        @input="validFilter('piece', false)"
                      ></m-form-checkbox>
                      <m-form-checkbox
                        class="color-white"
                        :label="'5+ ' + $t('translation.pièces')"
                        :name="$Utils.randomstring('t5')"
                        v-model="filter.room_5"
                        @input="validFilter('piece', false)"
                      ></m-form-checkbox>
                    </div>
                    <div class="d-flex flex-row justify-content-end">
                      <button
                        class="btn btn-primary mt-2 py-1 btn-filter  mr-3"
                        @click="cancelFilter('piece')"
                      >
                        {{ $t("translation.Effacer") }}
                      </button>
                      <button
                        class="btn btn-primary mt-2 py-1 btn-filter"
                        @click="closeFilters()"
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </div>
                <div @click="onclickDropdown" class="col-md-2">
                  <button
                    @click="openFilter('filter_situation')"
                    class="btn btn-primary uppercase w-100 mt-2 btn-filter"
                    :class="situation_txt ? 'btn_txt' : ''"
                  >
                    {{
                      situation_txt
                        ? situation_txt
                        : $t("translation.situation")
                    }}
                  </button>
                  <div class="dropdown-filter" v-if="filter_situation">
                    <div class="d-flex flex-column">
                      <m-form-checkbox
                        class="color-white"
                        label="Monaco"
                        :name="$Utils.randomstring('monaco')"
                        v-model="filter.monaco"
                        @input="validFilter('situation', false)"
                      ></m-form-checkbox>
                      <m-form-checkbox
                        class="color-white"
                        :label="$t('translation.Cote_dazur')"
                        :name="$Utils.randomstring('azur')"
                        v-model="filter.france"
                        @input="validFilter('situation', false)"
                      ></m-form-checkbox>
                    </div>
                    <div class="d-flex flex-row justify-content-end">
                      <button
                        class="btn btn-primary mt-2 py-1  mr-3"
                        @click="cancelFilter('situation')"
                      >
                        {{ $t("translation.Effacer") }}
                      </button>
                      <button
                        class="btn btn-primary mt-2 py-1 btn-filter"
                        @click="closeFilters()"
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </div>
                <div @click="onclickDropdown" class="col-md-2">
                  <button
                    @click="openFilter('filter_price')"
                    class="btn btn-primary uppercase w-100 mt-2 btn-filter"
                    :class="price_txt ? 'btn_txt' : ''"
                  >
                    {{ price_txt ? price_txt : $t("translation.budget") }}
                  </button>
                  <div class="dropdown-filter" v-if="filter_price">
                    <div class="d-flex flex-column">
                      <m-form-text
                        class="color-white"
                        :label="$t('translation.Budget minimum')"
                        :name="$Utils.randomstring('monaco')"
                        v-model="filter.budgetmin"
                        @input="validFilter('price', false)"
                      ></m-form-text>
                      <m-form-text
                        class="color-white"
                        :label="$t('translation.Budget maximum')"
                        :name="$Utils.randomstring('azur')"
                        v-model="filter.budgetmax"
                        @input="validFilter('price', false)"
                      ></m-form-text>
                    </div>
                    <div class="d-flex flex-row justify-content-end">
                      <button
                        class="btn btn-primary mt-2 py-1 mr-3"
                        @click="cancelFilter('price')"
                      >
                        {{ $t("translation.Effacer") }}
                      </button>
                      <button
                        class="btn btn-primary mt-2 py-1 btn-filter"
                        @click="closeFilters()"
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 d-flex flex-row align-items-center">
                  <div class="mt-2" @click="goOffersList()">
                    <icon
                      class="ml-2"
                      name="search"
                      width="25"
                      height="25"
                      color="#ee064b"
                    ></icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="row mt-4">
            <div class="col-md-10 offset-md-1">
              <div class="row">
                <div class=" col-md-12 w-100">
                  <div class="range-slider">
                    
                    <input
                      @change="slider"
                      v-model.number="filter.budgetmin"
                      :min="0"
                      :max="400000000"
                      :step="500"
                      type="range"
                    />
                    <input
                      @change="slider"
                      v-model.number="filter.budgetmax"
                      :min="0"
                      :max="400000000"
                      :step="500"
                      type="range"
                    />
                    <svg
                      class="svg-background"
                      ref="svgBudget"
                      width="100%"
                      height="5"
                    ></svg>
                    <svg
                      class="svg-budget"
                      :width="backgroudBudgetmax + '%'"
                      :style="'left:' + backgroudBudgetmin + 'px;'"
                      height="5"
                    ></svg>
                  </div>
                  
                  <div
                    class=" d-flex flex-row justify-content-between legend-range mt-2"
                  >
                    <div class="bis color-red">
                      {{ filter.budgetmin | formatPrice }}
                    </div>
                    <div class=" text-center budget">
                      <label
                        class="color-gray-light bis uppercase"
                        for="budget"
                        >{{ $t("translation.budget") }}</label
                      >
                    </div>
                    <div class="text-right bis color-red">
                      {{ filter.budgetmax | formatPrice }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- <div class="row d-flex flex-row justify-content-center mt-3">
            <button
              class="btn btn-primary primary-inverse uppercase bis"
              @click="goOffersList()"
            >
              {{ $t("translation.rechercher") }}
              <icon class="ml-2" name="search"></icon>
            </button>
          </div> -->
        </div>
      </div>
    </section>
    <section class="bg-gray-light py-5">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <img
              src="/images/pieterandpaul.jpg"
              class="photo-pieter"
              alt="pieter van Naeltwijck et Paul van Naeltwijck devant l'agence"
            />
          </div>
          <div class="col-md-6 col-bienvenue">
            <h1 class="text-center mb-4">{{ $t("translation.Bienvenue") }}</h1>
            <hr />
            <p class="mb-5 mt-4" v-html="$t('translation.Bienvenue_txt')"></p>
            <div class="d-flex flex-row justify-content-center">
              <img class="img-fluid" src="/images/map.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// select * from of_offers where of_web=1 order by rand() limit 0,3
export default {
  name: "home",
  components: {},
  data() {
    return {
      offers: [],
      filter: {
        page: 1,
        room: false,
        room_1: false,
        room_2: false,
        room_3: false,
        room_4: false,
        room_5: false,
        types: [],
        typesobj: {},
        france: false,
        monaco: false,
        rent: false,
        sale: false,
        budget: "",
        budgetmin: 0,
        budgetmax: 400000000
      },
      filter_type: false,
      filter_sale: false,
      filter_piece: false,
      filter_situation: false,
      filter_price: false,
      type: 0,
      sale: 0,
      search: "",
      backgroudBudgetmin: 0,
      backgroudBudgetmax: 100,
      sale_txt: "",
      type_txt: "",
      piece_txt: "",
      situation_txt: "",
      price_txt: "",
      carouselImages: [],
      slugOffer: ""
    };
  },
  computed: {
    items_of_type_filtered() {
      return this.$store.state.items.items_of_type.filter(item => {
        if (item.options == "8") return false;
        if (item.options == "9") return false;
        // console.log("item", item);
        return true;
      });
    },

    hasSearch() {
      let search = this.$options.filters.formatsearch(this.$t.bind(this));
      if (search) return true;
      return false;
    }
  },
  watch: {},
  async mounted() {
    this.setCarousselHeight();
    setTimeout(() => {
      this.setCarousselHeight();
      setTimeout(() => {
        this.setCarousselHeight();
        setTimeout(() => {
          this.setCarousselHeight();
        }, 1000);
      }, 1000);
    }, 1000);
    window.addEventListener("resize", this.setCarousselHeight);

    // console.log("je passe");
    // get images carousel from offer with param of_carousel_homepage = true
    let params = { carousel: true, isweb: false };
    let response = await this.$axios.get(
      this.$config.server_url + "/web/1.0/offers",
      { params }
    );
    if (!response || !response.data) return;
    let offerCarousel = response.data.data[0];

    if (offerCarousel && offerCarousel.images.length)
      this.carouselImages = offerCarousel.images;
    if (offerCarousel) this.slugOffer = offerCarousel.of_slug_fr;
    this.$forceUpdate();
    // this.$store.dispatch("cancelAllFilter");
    window.addEventListener("click", this.onWindowClick);
    this.search = this.$options.filters.formatsearch(this.$t.bind(this));
    // this.search = this.yourResearch();
  },
  destroyed() {
    window.removeEventListener("click", this.onWindowClick);
    window.removeEventListener("resize", this.setCarousselHeight);
  },
  methods: {
    setCarousselHeight() {
      let h =
        this.$$(window).height() -
        this.$$(this.$root.$children[0].$refs.mainheader).height();
      if (h < 423) h = 423;
      this.$refs.containercarousel.style.height = h + "px";

      this.$$(".carousel-homeimage").height(h);
    },
    slider: function() {
      if (this.filter.budgetmin > this.filter.budgetmax) {
        var tmp = this.filter.budgetmax;
        this.filter.budgetmax = this.filter.budgetmin;
        this.filter.budgetmin = tmp;
      }
      this.backgroudBudgetmax = (this.filter.budgetmax * 100) / 400000000;
      let percentagemin = (this.filter.budgetmin * 100) / 400000000;
      let widthbudget = this.$refs.svgBudget.width.baseVal.value;
      this.backgroudBudgetmin = (widthbudget * percentagemin) / 100;
      this.backgroudBudgetmax = this.backgroudBudgetmax - percentagemin;
      this.validFilter("budget", false);
    },

    openFilter(key, $event) {
      let open = this[key];
      // console.log("open", open);
      this.filter_type = false;
      this.filter_sale = false;
      this.filter_piece = false;
      this.filter_situation = false;
      this.filter_price = false;
      if (!open) this[key] = true;
    },
    onclickDropdown(evt) {
      evt.stopPropagation();
    },
    onWindowClick() {
      this.openFilter("filter_none");
    },
    deleteSearch() {
      this.$store.dispatch("cancelAllFilter");
      this.filter = this.$_.cloneDeep(this.$store.state.offersfilters);
      this.search = this.$options.filters.formatsearch(this.$t.bind(this));
    },
    validFilter(filter, closeFilter = true) {
      if (closeFilter) this["filter_" + filter] = false;
      // console.log("this.filter", this.filter);
      this.$store.commit("set_offersfilters", this.filter);
      //this.search = this.$options.filters.formatsearch(this.$t.bind(this));
      this[filter + "_txt"] = this.$options.filters.formatsearchTxt(
        filter,
        this.$t.bind(this)
      );
      // console.log('this[filter + "_txt"] ', this[filter + "_txt"]);
      // this.search = this.yourResearch();
      /* this.loadOffers(); */
    },
    closeFilters() {
      this["filter_sale"] = false;
      this["filter_type"] = false;
      this["filter_piece"] = false;
      this["filter_situation"] = false;
      this["filter_price"] = false;
    },
    cancelFilter(filter) {
      // console.log("filter", filter);
      switch (filter) {
        case "type":
          this.type_txt = "";
          this.filter.types = [];
          this.type = 0;
          break;
        case "price":
          this.price_txt = "";
          this.filter.budgetmin = 0;
          this.filter.budgetmax = 400000000;
          break;
        case "piece":
          this.piece_txt = "";
          this.filter.room_1 = false;
          this.filter.room_2 = false;
          this.filter.room_3 = false;
          this.filter.room_4 = false;
          this.filter.room_5 = false;
          break;
        case "sale":
          this.sale_txt = "";
          this.sale = 0;
          this.filter.rent = false;
          this.filter.sale = false;
          break;
        case "situation":
          this.situation_txt = "";
          this.filter.monaco = false;
          this.filter.france = false;
          break;
        default:
          break;
      }
      // console.log("sale_txt", sale_txt);
      this["filter_" + filter] = false;
      this.$store.commit("set_offersfilters", this.filter);
      this.search = this.$options.filters.formatsearch(this.$t.bind(this));
      //this.loadOffers();
    },
    // cancelAllFilter() {
    //   this.filter.types = [];
    //   this.type = 0;
    //   this.filter.room_1 = false;
    //   this.filter.room_2 = false;
    //   this.filter.room_3 = false;
    //   this.filter.room_4 = false;
    //   this.filter.room_5 = false;
    //   this.filter.monaco = false;
    //   this.filter.france = false;
    //   this.filter.rent = false;
    //   this.filter.sale = false;
    //   this.filter.budgetmin = 0;
    //   this.filter.budgetmax = 400000000;
    //   this.sale = 0;
    // },
    goOffersList(situation = "") {
      let filter = this.$_.cloneDeep(this.$store.state.offersfilters);
      if (situation) {
        this.$store.dispatch("cancelAllFilter");
        filter = this.$_.cloneDeep(this.$store.state.offersfilters);
        if (situation == "monaco") filter.monaco = true;
        if (situation == "france") filter.france = true;
      }
      this.$store.commit("set_offersfilters", filter);
      this.$router.push("/offers");
    }
    // async loadOffers() {
    //   this.filter.types = [];
    //   if (this.type) {
    //     this.filter.types.push(this.type);
    //   }
    //   let params = { random: true };
    //   let response = await this.$axios.get(
    //     this.$config.server_url + "/web/1.0/offers",
    //     { params }
    //   );
    //   if (!response || !response.data) return;
    //   this.offers = response.data.data;
    //   this.$store.commit("set_offers", {
    //     offers: response.data.meta.rows_all
    //   });
    // },
    // goOffer(offer) {
    //   this.$router.push("/immo/offer/" + offer.of_slug_fr);
    // }
  }
};
</script>
<style scoped lang="scss">
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
@import "../scss/styles.scss";
.col-photo-monaco,
.col-photo-azur {
  cursor: pointer;
  .photo-monaco,
  .lieu-monaco,
  .lieu-azur,
  .photo-azur {
    transition: all 0.5s ease;
  }
  position: relative;
  padding: 0;
  height: 100px;
  img {
    object-fit: cover;
    width: 100%;
  }
}

.btn-sm {
  padding: 1px 15px;
}

.lieu-monaco,
.lieu-azur {
  width: 100%;
  //height: 100%;
  font-size: 4rem;
  font-weight: 400;
  font-family: $font-nunito;
  // letter-spacing: 5px;
  color: #fff;
  /*   position: absolute;
  top: 40%;
  left: 0;
  z-index: 100000; */
  text-align: center;
}
.container-carousel {
  height: 80vh;
  position: relative;
}
.container-recherche {
  position: absolute;
  bottom: 20px;
  width: 100%;
  z-index: 100;
}
.elements-recherche {
  background-color: #ffffff9c;
  padding: 20px;
  border-radius: 5px;
}

.bg-carousel {
  background-position: center;
  background-size: cover;
}
.col-photo-monaco:hover {
  .lieu-monaco {
    color: #fff;
  }
  .photo-monaco {
    opacity: 0.5;
  }
}
.col-photo-azur:hover {
  .lieu-azur {
    color: #fff;
  }
  .photo-azur {
    opacity: 0.5;
  }

  @media (min-width: 576px) {
    .col-photo-monaco,
    .col-photo-azur {
      height: 300px;
    }
  }
  @media (min-width: 768px) {
    .col-photo-monaco,
    .col-photo-azur {
      height: 400px;
    }
  }
  .col-bienvenue {
    padding: 60px 50px;
  }
}
.col-bienvenue h1 {
  font-family: $font-nunito;
}
@media (min-width: 992px) {
  .col-photo-monaco,
  .col-photo-azur {
    height: 400px;
  }
}
@media (min-width: 1200px) {
  .col-photo-monaco,
  .col-photo-azur {
    height: 500px;
  }
}

.legend-range {
  position: relative;
}
.budget {
  position: absolute;
  top: 0;
  width: 100%;
  text-align: center;
}
.range-budget {
  -webkit-appearance: none;
  width: 100%;
  height: 4px;
  border-radius: 4px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: opacity 0.15s ease-in-out;
  transition: opacity 0.15s ease-in-out;
}
.dropdown-filter {
  position: absolute;
  bottom: calc(100% - 5px);
  min-width: calc(100% - 30px);
  z-index: 100;
  margin-top: 5px;
  border: 1px solid #cccccc;
  border-radius: 0;
  margin-bottom: 10px;
  background-color: #650107;
  padding: 15px;
  //box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.15);
}
// .withcursor {
//   cursor: pointer;
// }
// // recherche
// .select .input-group {
//   min-width: 220px;
// }
// .filter .form-group {
//   //margin-bottom: 0;
// }
// .filter-selected {
//   background-color: #fdd40f;
// }
// .btn-filter {
//   margin-left: 10px;
//   margin-bottom: 10px;
//   position: relative;
//   border: 1px solid #cccccc;
//   border-radius: 10px;
//   padding: 5px 10px;
//   cursor: pointer;
// }
// .btn-filter:hover {
//   background-color: #e8e8e8;
// }
// .dropdown-filter {
//   margin-top: 5px;
//   border: 1px solid #cccccc;
//   border-radius: 5px;
//   margin-bottom: 10px;
//   background-color: #fff;
//   padding: 15px;
//   box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.15);
// }
// @media (min-width: 576px) {
//   .dropdown-filter {
//     //min-width: 250px;
//     position: absolute;
//     z-index: 1000;
//     top: 100%;
//     margin-top: 5px;
//     margin-bottom: 0px;
//   }
//   .container-filter {
//     display: flex;
//     flex-direction: row;
//     flex-wrap: wrap;
//   }
// }
// les offres
.offer-title {
  font-size: 18px;
  margin-top: 5px;
}
.offer-type-detail {
  padding: 2px 7px;
  border-radius: 5px;
  color: #fff;
}
.family {
  background-color: #ffc400;
}
.appart {
  background-color: #03b1ff;
}
////////////////////////

.range-slider {
  width: 100%;
  margin: auto;
  text-align: center;
  position: relative;
  height: 1em;
}

.range-slider svg,
.range-slider input[type="range"] {
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: #ee064b;
}
.range-slider .svg-background,
.range-slider input[type="range"] {
  background-color: #0c0c0c;
}
.range-slider .svg-budget {
  background-color: #ee064b;
  z-index: 0;
}

input[type="number"] {
  border: 1px solid #ddd;
  text-align: center;
  font-size: 1.6em;
  -moz-appearance: textfield;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"]:invalid,
input[type="number"]:out-of-range {
  border: 2px solid #ff6347;
}

input[type="range"] {
  -webkit-appearance: none;
  width: 100%;
}
input[type="range"]:focus {
  outline: none;
}

input[type="range"]:focus::-webkit-slider-runnable-track {
  background: #2497e3;
}

input[type="range"]:focus::-ms-fill-lower {
  background: #2497e3;
}

input[type="range"]:focus::-ms-fill-upper {
  background: #2497e3;
}

input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 5px;
  cursor: pointer;
  // animate: 0.2s;
  background: #2497e3;
  border-radius: 1px;
  box-shadow: none;
  border: 0;
}

input[type="range"]::-webkit-slider-thumb {
  z-index: 2;
  position: relative;
  box-shadow: 0px 0px 0px #000;
  border: 1px solid #2497e3;
  height: 18px;
  width: 18px;
  border-radius: 25px;
  background: #a1d0ff;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -7px;
}
.photo-pieter {
  max-width: 90%;
  height: auto;
  margin-top: 29px;
}
// .btn_txt {
//   font-size: 12px;
//   text-transform: lowercase;
//   padding: 15px 5px;
//   overflow: hidden;
// }

.btn-filter {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
